import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { InvoiceGeneratorProps } from "./interfaces/invoice-generator-props";
import Step from "./UI/Step";
import TaxInfo from "./TaxInfo/TaxInfo";
import TicketSearch from "./TicketSearch/TicketSearch";
import Invoice from "./Invoice/Invoice";
import LogoImage from "../assets/img/logo.png";

const InvoiceGenerator = () => {
  const [searchParams] = useSearchParams();

  const [currentStep, setCurrenStep] = useState(1);
  const [data, setData] = useState<InvoiceGeneratorProps>({
    rfc: searchParams.get("rfc") || "",
    ticket: searchParams.get("ticket") || "",
    code: searchParams.get("codigo") || "",
    email: "",
    fiscalRegime: undefined,
    name: "",
    clientId: "",
    saleId: "",
    invoiceId: "",
    postalCode: "",
    paymentForm: undefined
  });

  const handleNextStep = (newData: InvoiceGeneratorProps) => {
    setData((prev) => ({ ...prev, ...newData }));
    setCurrenStep((prev) => prev + 1);
  };

  const handlePrevStep = (newData: InvoiceGeneratorProps) => {
    setData((prev) => ({ ...prev, ...newData }));
    setCurrenStep((prev) => prev - 1);
  };

  const steps = [
    <TicketSearch onNextStep={handleNextStep} data={data} />,
    <TaxInfo
      onNextStep={handleNextStep}
      onPrevStep={handlePrevStep}
      data={data}
    />,
    <Invoice data={data} />,
  ];

  return (
    // CONTENEDOR PRINCIPAL
    <div
      className="min-h-screen w-full bg-slate-50 flex flex-col items-center justify-start md:justify-center md:p-4 font-sans relative"
      style={{
        backgroundImage: "radial-gradient(#cbd5e1 1.5px, transparent 1.5px)",
        backgroundSize: "32px 32px"
      }}
    >

      {/* TARJETA */}
      <div className="w-full md:max-w-md bg-white md:rounded-2xl shadow-none md:shadow-2xl md:border md:border-slate-200 overflow-hidden min-h-screen md:min-h-0 flex flex-col transition-all duration-300 z-10">

        {/* 1. HEADER CON LOGO (Más aireado) */}
        {/* ANTES: p-6 pb-0 */}
        {/* AHORA: pt-8 pb-6 (Más espacio arriba y abajo del logo) */}
        <div className="bg-white pt-8 pb-6 px-6 flex justify-center shrink-0">
          <img src={LogoImage} alt="EasyGas" className="h-12 object-contain" /> {/* Subí h-10 a h-12 para que luzca más */}
        </div>

        {/* 2. STEPPER (Más limpio) */}
        {/* ANTES: px-6 py-4 */}
        {/* AHORA: px-8 (Más margen lateral) y py-2 (Reducimos un poco vertical para agruparlo visualmente con el logo o separarlo, aquí lo dejamos neutro) */}
        <div className="bg-white px-8 py-2 shrink-0">
          <div className="flex justify-between items-center px-2">
            <Step number={1} label="ticket" isActive={currentStep === 1} />
            <div className={`h-0.5 w-full mx-4 transition-colors duration-500 ${currentStep > 1 ? 'bg-[#84cc16]' : 'bg-slate-200'}`}></div>

            <Step number={2} label="datos" isActive={currentStep === 2} />
            <div className={`h-0.5 w-full mx-4 transition-colors duration-500 ${currentStep > 2 ? 'bg-[#84cc16]' : 'bg-slate-200'}`}></div>

            <Step number={3} label="factura" isActive={currentStep === 3} />
          </div>
        </div>

        {/* 3. CONTENIDO (Aquí estaba el mayor problema) */}
        {/* ANTES: p-6 pt-2 */}
        {/* AHORA: p-8 (Padding uniforme de 32px por todos lados. Esto separa el formulario de los pasos) */}
        <div className="p-8 grow flex flex-col justify-start md:justify-center">
          {steps[currentStep - 1]}
        </div>

        {/* FOOTER MÓVIL */}
        <div className="p-6 text-center shrink-0 bg-white md:hidden">
          <p className="text-xs text-slate-400">Powered by <span className="font-bold text-slate-500">EASYGAS</span></p>
        </div>

      </div>

      {/* FOOTER ESCRITORIO */}
      <div className="hidden md:block absolute bottom-6 text-center w-full">
        <p className="text-xs text-slate-500 font-medium tracking-wide">
          Powered by <span className="font-bold text-slate-700">EASYGAS</span>
        </p>
        <p className="text-[10px] text-slate-400 mt-1">Plataforma de Control Volumétrico Certificada</p>
      </div>

    </div>
  );
};

export default InvoiceGenerator;
